import React, { type PropsWithChildren } from 'react';
import { Box, xcss, type BoxProps } from '@atlaskit/primitives';

const Footer = ({ children, testId }: PropsWithChildren<BoxProps<'div'>>) => {
	return (
		<Box xcss={footerStyles} testId={testId}>
			{children}
		</Box>
	);
};
const footerStyles = xcss({
	gridArea: 'footer',
});

export default Footer;
